module.exports = __webpack_public_path__ + "static/img/picc8.a98f160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picc8.png
// module id = KoFF
// module chunks = 0